import React from 'react';
import { IAdresse } from '../types';
import { Column, Header, Text } from '@mattilsynet/mt-ui';
interface IVirksomhetAdresseViewProps {
  tittel: string;
  adresse?: IAdresse;
}
export const VirksomhetAdresseView = ({
  tittel,
  adresse
}: IVirksomhetAdresseViewProps) => {
  return <Column justify={'flex-start'} align={'flex-start'} spacing={1} data-sentry-element="Column" data-sentry-component="VirksomhetAdresseView" data-sentry-source-file="VirksomhetAdresseView.tsx">
      <Header as="h3" size="normal" data-sentry-element="Header" data-sentry-source-file="VirksomhetAdresseView.tsx">
        {tittel}
      </Header>
      <Column data-sentry-element="Column" data-sentry-source-file="VirksomhetAdresseView.tsx">
        {(adresse?.adresse?.length ?? 0) > 0 && adresse?.adresse.map((adresse, index) => <Text key={index} textAlign="left">
              {adresse}
            </Text>)}
      </Column>
      <Column data-sentry-element="Column" data-sentry-source-file="VirksomhetAdresseView.tsx">
        <Text data-sentry-element="Text" data-sentry-source-file="VirksomhetAdresseView.tsx">{`${adresse?.postnummer || ''} ${adresse?.poststed || ''}`}</Text>
      </Column>
    </Column>;
};